module.exports = __webpack_public_path__ + "img/1.23e43d5d.jpg";